import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const variantPlaceholderType = ["control", "template"] as const;
export type VariantPlaceholderType = (typeof variantPlaceholderType)[number];

export interface VariantPlaceholderProps {
  type: VariantPlaceholderType;
  hasTemplate?: boolean;
  message?: string;
}

export const VariantPlaceholder = memo(function VariantPlaceholder({
  type,
  hasTemplate = false,
  message,
}: VariantPlaceholderProps) {
  const defaultMessage =
    type === "control"
      ? "Control group - no message will be sent"
      : hasTemplate
        ? "Template configured"
        : "No template selected - click Edit to configure";

  return (
    <Flex
      bgColor="secondary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      gap="sm"
      p="md"
      radius="sm"
      w="full"
    >
      <Text fontSize="xs" textColor="tertiary">
        {message ?? defaultMessage}
      </Text>
    </Flex>
  );
});
